import React, { Suspense } from 'react'
import {
  getSignatureRequest,
  updateSignatureRequest,
  getPages,
  setAgreedDocuments,
  getExpirePage,
} from '../actions/actions'
import { connect } from 'react-redux'
import Pages from '../components/Pages/Pages'
import Header from '../components/Header/Header'
const DocumentsList = React.lazy(() => import('../components/DocumentsList/DocumentsList'))
const SignatureScreen = React.lazy(() => import('../components/SignatureScreen/SignatureScreen'))

const InitContainers = (props) => {
  const [screenState, setScreenState] = React.useState('welcome')
  const [accepted, setAccepted] = React.useState(props.signEmpty)
  let screen
  switch (screenState) {
    case 'docs':
      screen = (
        <Suspense fallback={null}>
          <DocumentsList next="sign" setScreenState={setScreenState} {...props} />
        </Suspense>
      )
      break
    case 'sign':
      screen = (
        <Suspense fallback={null}>
          <SignatureScreen
            accepted={accepted}
            setAccepted={setAccepted}
            next="success"
            back="docs"
            setScreenState={setScreenState}
            {...props}
          />
        </Suspense>
      )
      break
    case 'welcome':
      if (props?.signatureRequest?.attributes) {
        screen = <Pages setScreenState={setScreenState} next="docs" text={props.pages.welcome_page} />
      }
      break
    case 'success':
      screen = <Pages setScreenState={setScreenState} text={props.pages.success_page} />
      break
    case 'error':
      screen = <Pages setScreenState={setScreenState} text={props.expirePage} />
      break
    default:
      // TODO implement default case
      break
  }

  React.useEffect(() => {
    if (props.signatureRequest?.attributes?.field_signed === true) {
      setScreenState('success')
    }
  }, [props.signatureRequest?.attributes?.field_signed])

  React.useEffect(() => {
    if (props.error) {
      setScreenState('error')
    }
  }, [props.error])

  React.useEffect(() => {
    props.getSignatureRequest()
    props.getPages()
    props.getExpirePage()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <div>
        <Header />
        {screen}
      </div>
    </>
  )
}

const mapStateToProps = (state) => ({
  agreedAllDocuments: state.signatureRequest.agreedAllDocuments,
  documentsIds: state.signatureRequest.documentsIds,
  error: state.signatureRequest.error,
  initialDocumentsIds: state.signatureRequest.initialDocumentsIds,
  isLoading: state.signatureRequest.isLoading,
  pages: state.signatureRequest.pages,
  signatureRequest: state.signatureRequest.signatureRequest,
  signEmpty: state.signatureRequest.signEmpty,
  expirePage: state.signatureRequest.expire_page,
})

const mapDispatchToProps = (dispatch) => {
  return {
    getSignatureRequest: () => {
      dispatch(getSignatureRequest())
    },
    updateSignatureRequest: (data) => {
      dispatch(updateSignatureRequest(data))
    },
    getPages: () => {
      dispatch(getPages())
    },
    getExpirePage: () => {
      dispatch(getExpirePage())
    },
    setAgreedDocuments: (id) => {
      dispatch(setAgreedDocuments(id))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(InitContainers)
